/**
 * Перевіряє чи є право у поточного юзера на виконання певної дії над ресурсом
 */
// hooks/usePermission.js
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { selectUser } from "../redux/auth/selectors.js";

const EMPTY_PERMISSIONS = []; // стабільний референс поза хуком

export function useCan() {
  const permissions = useSelector(
    state => selectUser(state)?.permissions ?? EMPTY_PERMISSIONS
  );

  return useCallback(
    (resource, action) => {
      const perm = permissions.find(
        p => p.resource === resource && p.action === action
      );
      return perm?.status === 1;
    },
    [permissions]
  );
}

// Використання в компоненті
// const can = useCan();
// can('invoices', 'create');
